<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
	<div id="app" :class="vueAppClasses">
		<router-view @setAppClasses="setAppClasses" />
	</div>
</template>

<script>
import store from "@/store/store";

import $ from "jquery";
import themeConfig from "@/../themeConfig.js";
import VueCookies from "vue-cookies";
export default {
	data() {
		return {
			vueAppClasses: [],
		};
	},
	computed: {
		stateNotifPopUp: () => {
			return store.state.isNotifPopUp;
		},
		stateContractPopUpp: () => {
			return store.state.isContractPopUp;
		},
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
	},
	watch: {
		"$store.state.theme"(val) {
			this.toggleClassInBody(val);
		},
		"$vs.rtl"(val) {
			document.documentElement.setAttribute("dir", val ? "rtl" : "ltr");
		},
	},
	methods: {
		toggleClassInBody(className) {
			if (className == "dark") {
				if (document.body.className.match("theme-semi-dark"))
					document.body.classList.remove("theme-semi-dark");
				document.body.classList.add("theme-dark");
			} else if (className == "semi-dark") {
				if (document.body.className.match("theme-dark"))
					document.body.classList.remove("theme-dark");
				document.body.classList.add("theme-semi-dark");
			} else {
				if (document.body.className.match("theme-dark"))
					document.body.classList.remove("theme-dark");
				if (document.body.className.match("theme-semi-dark"))
					document.body.classList.remove("theme-semi-dark");
			}
		},
		setAppClasses(classesStr) {
			this.vueAppClasses.push(classesStr);
		},
		handleWindowResize() {
			this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

			// Set --vh property
			document.documentElement.style.setProperty(
				"--vh",
				`${window.innerHeight * 0.01}px`
			);
		},
		handleScroll() {
			this.$store.commit("UPDATE_WINDOW_SCROLL_Y", window.scrollY);
		},
	},

	mounted() {
		//FOR NOTIFICATION BOX WHEN CONTRACT IS OPENED//
		window.addEventListener("click", function (event) {
			if (!window.fromNotif) {
				if (window.isNotifPopUp && !window.isContractPopUp) {
					$(".notification-menu").hide();
					$(".notification-menu-header").hide();
					$(".notification-menu-footer").hide();
					window.isNotifPopUp = false;
				}
			}
			window.fromNotif = false;
			if (window.isContractPopUp && !window.beforeContract) {
				window.isContractPopUp = false;
			}
			window.beforeContract = false;
		});
		//FOR NOTIFICATION BOX WHEN CONTRACT IS OPENED//

		this.toggleClassInBody(themeConfig.theme);
		this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);
		this.$store.dispatch("updateWindowHeigth", window.outerHeight);
		//this.$store.dispatch("updateTableHeight", window.innerHeight);
		this.$nextTick(() => {
			window.addEventListener("resize", () => {
				this.$store.dispatch("updateWindowHeigth", window.outerHeight);
				//this.$store.dispatch("updateTableHeight", window.innerHeight);
			});
		});

		let vh = window.innerHeight * 0.01;
		// Then we set the value in the --vh custom property to the root of the document
		document.documentElement.style.setProperty("--vh", `${vh}px`);
		//fucntion running every ten minutes for notification
		this.$nextTick(function () {
			window.setInterval(() => {
				this.$store.dispatch("getPersonalNotificationList", this.activeUser.id);
				this.$store.dispatch("getAllFlexibleMissions");
			}, 200000);
		});
	},
	async created() {
		window.isNotifPopUp = false;
		window.isContractPopUp = false;
		let dir = this.$vs.rtl ? "rtl" : "ltr";
		document.documentElement.setAttribute("dir", dir);

		window.addEventListener("resize", this.handleWindowResize);
		window.addEventListener("scroll", this.handleScroll);
	},
	destroyed() {
		window.removeEventListener("resize", this.handleWindowResize);
		window.removeEventListener("scroll", this.handleScroll);
		clearInterval();
	},
};
</script>
